import { money, moneyK } from './format.js';

// The Roth conversion, shown rather than played with.
//
// This was a pair of sliders until the advisor lead saw it: "I don't really
// want the advisors being able to change things during a second assessment
// meeting. There would be no toggling of anything." The second meeting is
// presented; the modeling belongs to the plan. So the panel now shows ONE
// deterministic schedule, computed from the client's own numbers: the whole
// tax-deferred balance spread evenly across the years the window still has.
// Not a recommendation, and it says so; it exists to make the size of the
// lever visible, which is the argument for the plan that prices it properly.
//
// The cost stays beside the benefit, stated as taxable income and never as a
// tax bill, for the same reason as always: the bracket is not something the
// questionnaire asks for.

export default function RothConversionPanel({ roth }) {
  if (!roth) return null;

  if (roth.windowYears <= 0) {
    return (
      <div className="asmt-subsection">
        <h3 className="asmt-subhead">Converting after withdrawals have started</h3>
        <p className="asmt-note">
          Required withdrawals have already begun, so a conversion now sits on top of
          the amount you have to take out anyway. It can still be worth doing, and it
          is a conversation for the full plan.
        </p>
      </div>
    );
  }

  // No amount is proposed here. The page used to illustrate moving the entire
  // tax-deferred balance out across the remaining years and show the resulting
  // figures beside today's, which reads as a recommendation for a number
  // nobody chose. What is genuinely known is the window and the pool; what to
  // convert depends on brackets, on what the conversion is paid with, and on
  // the rest of the plan.
  return (
    <div className="asmt-subsection asmt-roth">
      <h3 className="asmt-subhead">The years while the timing is still yours</h3>
      <p className="asmt-note">
        You have {roth.windowYears} {roth.windowYears === 1 ? 'year' : 'years'} before {roth.windowClosesIn},
        when the withdrawals stop being optional. Until then, moving money out of the
        tax-deferred pool is a decision about which year to pay the tax in, rather than
        whether to pay it.
      </p>

      <div className="asmt-roth-compare">
        <div className="asmt-roth-row is-total">
          <span>In the tax-deferred pool today</span>
          <span />
          <span />
          <span className="asmt-roth-after">{moneyK(roth.deferredAfter)}</span>
        </div>
      </div>

      <div className="asmt-callout">
        <strong>What the plan works out.</strong>{' '}
        How much to convert, in which years, and what bracket each conversion fills.
        Every dollar moved is taxable income in the year it moves, so the answer depends
        on your other income that year and on what pays the tax. That is the work of the
        financial plan, and it is why the size of this pool is worth pricing properly.
      </div>
    </div>
  );
}
